import React, { useContext, useEffect } from "react";
import Row from "@amzn/meridian/row";
import ControlGroup from "@amzn/meridian/control-group";
import Checkbox from "@amzn/meridian/checkbox";
import RadioButton from "@amzn/meridian/radio-button";
import Column from "@amzn/meridian/column";
import PVAChart from "./PVAChart";
import { PVAOverviewContext } from "../overview/context/PVAOverviewContext";
import { FormattedMessage } from "react-intl";

const ChartView = (data) => {
  const { pvaData, dispatch } = useContext(PVAOverviewContext);

  const getOption = (processName) => {
    return processName === "inbound"
      ? [
          { key: "inbound", value: "chart.inbound", defaultMessage: "Arrive" },
          { key: "induct", value: "chart.induct", defaultMessage: "Induct" },
          { key: "sort", value: "chart.sort", defaultMessage: "Sort" },
        ]
      : [
          { key: "pick", value: "chart.pick", defaultMessage: "Pick" },
          { key: "stage", value: "chart.stage", defaultMessage: "Stage" },
        ];
  };

  useEffect(() => {
    if (data.view.processName === "outbound") {
      dispatch({
        type: "SET_PVA_GRAPH_PROCESS",
        data: { processName: ["pick", "stage"] },
      });
    }
  }, []);

  return (
    <React.Fragment>
      <Row widths={["grid-2", "grid-10"]} spacingInset="medium large">
        <div>
          <ControlGroup
            name="option"
            onChange={(value) =>
              dispatch({
                type: "SET_PVA_GRAPH_PROCESS",
                data: { processName: value },
              })
            }
            value={pvaData.pvaGraphData.processName}
          >
            {getOption(data.view.processName).map((option) => (
              <Checkbox key={option.key} value={option.key}>
                <FormattedMessage
                  id={option.value}
                  defaultMessage={option.defaultMessage}
                />
              </Checkbox>
            ))}
          </ControlGroup>
          <Column spacingInset="small none none">
            <ControlGroup
              name="toppings"
              onChange={(value) =>
                dispatch({
                  type: "SET_PVA_GRAPH_GRANULARITY",
                  data: { granularity: value },
                })
              }
              value={pvaData.pvaGraphData.granularity}
            >
              <RadioButton value="15">
                <FormattedMessage
                  id="chart.minute_15"
                  defaultMessage="15 Minutes"
                />
              </RadioButton>
              <RadioButton value="cumulative_15">
                <FormattedMessage
                  id="chart.cumulative"
                  defaultMessage="Cumulative"
                />
              </RadioButton>
            </ControlGroup>
          </Column>
        </div>
        <div>
          {pvaData.overviewData.flowPVAData ? (
            <PVAChart
              processName={data.view.processName}
              pvaData={{ pvaData: pvaData }}
            />
          ) : (
            ""
          )}
        </div>
      </Row>
    </React.Fragment>
  );
};

export default ChartView;



// WEBPACK FOOTER //
// ./src/components/chart/ChartView.js